export default __webpack_public_path__ + "2d9cf66.png";